import { render, staticRenderFns } from "./msg2.vue?vue&type=template&id=362c9e32&scoped=true&"
import script from "./msg2.vue?vue&type=script&lang=js&"
export * from "./msg2.vue?vue&type=script&lang=js&"
import style0 from "./msg2.vue?vue&type=style&index=0&id=362c9e32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c9e32",
  null
  
)

export default component.exports